import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import './index.css'
import './atelier.css'
import App from './App.tsx'
import { AppTree } from './AppTree.tsx'
import { initPostHog } from './posthog'
import { initSentry } from './sentry'

initSentry()
const posthogClient = initPostHog()

const app = (
  <AppTree>
    <App />
  </AppTree>
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {posthogClient ? (
      <PostHogProvider client={posthogClient}>{app}</PostHogProvider>
    ) : (
      app
    )}
  </StrictMode>,
)
